import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
//import RichTextEditor from 'react-rte'
import DatePicker from 'react-datepicker'
import { registerLocale } from 'react-datepicker'
import { submitFuehrerschein, fetchOneUserByUsername, fetchOneUserByAuth } from '../../actions'
import de from 'date-fns/locale/de'
import "react-datepicker/dist/react-datepicker.css";

registerLocale('de', de);

const inputStyle = {
  marginBottom: '10px'
}

class FuehrerscheinNew extends Component {

  constructor(props) {
    super(props);

    this.state = {
      rtvalue: '',
      startDate: new Date()
    }
    this.cancelLink = this.cancelLink.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    //this.dataThere = this.dataThere.bind(this);
  }

  componentDidMount() {
    this.props.fetchOneUserByAuth();
  }

  cancelLink() {
    var cancelPath = '/';
    if (this.props.auth) {
      cancelPath = '/fahrer';
    }
    return cancelPath;
  }

  isAdmin() {
    if (!this.props.auth) {
      return false;
    }
    if (this.props.auth.roles.indexOf('admin')>-1) {
      return true;
    } else {
      return false;
    }
  }

  handleDateChange(date) {
    this.setState({
      startDate:date
    });
  }

  render() {

    var initValues = {vorname:'',nachname:'',licenseId:'',licenseDate:null, newF:true};

    if (initValues) {
      if (!initValues.email) {
        initValues.email = this.props.match.params.email;
      }
    }

    //const auth = this.props.auth;

    return (
      <div>

        <h4 style={{fontStyle:'italic'}}>Führerschein hinzufügen</h4>

        <Formik
          initialValues={initValues}
          validate={values => {
            let errors = {};
            if (!values.email) {
              errors.email = 'Die Mailadresse ist erforderlich.';
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = 'Keine gültige Email-Adresse';
            }
            /*
            if (!values.vorname) {
              errors.vorname = 'Der Vorname ist erforderlich.';
            }
            if (!values.nachname) {
              errors.nachname = 'Der Nachname ist erforderlich.';
            }
            */

            values.licenseDate = this.state.startDate;

            console.log("licenseDate in validate:", values.licenseDate);
            /*
            if (!values.licenseDate) {
              errors.licenseDate = 'Das Ausstellungsdatum ist erforderlich.';
            }
            */

            if (!values.licenseId) {
              errors.licenseId = 'Die Führerscheinnummer ist erforderlich.';
            }

            return errors;
          }}

          onSubmit={(values, { setSubmitting }) => {
            console.log("submitting FuehrerscheinNew");
              setSubmitting(true);
              this.props.submitFuehrerschein( values, this.props.history );
              setSubmitting(false);
          }}
        >

          {({ isSubmitting, props, setFieldValue, initValues, values, setSubmitting }) => (

            <Form
              onKeyPress={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
              }
            }}>
              <label htmlFor="vorname">Vorname</label>
              <Field name="vorname" style={inputStyle} placeholder="Vorname" />
              <ErrorMessage name="vorname" component="div" />


              <label htmlFor="nachname">Nachname</label>
              <Field name="nachname" style={inputStyle} placeholder="Nachname" />
              <ErrorMessage name="nachname" component="div" />

              <label htmlFor="licenseDate">Ausstellungsdatum</label>
              <DatePicker
                selected={this.state.startDate}
                locale='de'
                dateFormat="d. MMMM yyyy"
                onChange={this.handleDateChange}
                showYearDropdown
                dateFormatCalendar="MMMM"
                scrollableYearDropdown
                yearDropdownItemNumber={50}
                name="licenseDate" />
              <ErrorMessage name="licenseDate" component="div" />

              <label htmlFor="licenseId">Nummer des Führerscheins</label>
              <Field name="licenseId" style={inputStyle} />
              <ErrorMessage name="licenseId" component="div" />

              <label htmlFor="email">Email</label>
              <Field name="email" style={inputStyle} />
              <ErrorMessage name="email" component="div" />

              <Field type="hidden" name="newFn" value="true" />

              <Link to={this.cancelLink()} style={{marginRight: '10px'}} type="cancel">
                <button className="btn btn-secondary" >
                <span style={{color: 'white'}}>Abbrechen</span>
                </button>
              </Link>
              <button className="btn btn-default" type="submit" disabled={isSubmitting}>
                Absenden
              </button>
            </Form>
          )}
        </Formik>
        <div style={{height: "80px"}}></div>
      </div>
    )}
}

const mapDispatchToProps = {
  fetchOneUserByUsername,
  fetchOneUserByAuth,
  submitFuehrerschein
}

function mapStateToProps({ auth, singleUser }) {
	return { auth, singleUser }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(FuehrerscheinNew);



// WEBPACK FOOTER //
// ./src/components/fahrer/FuehrerscheinNew.js